/**
 * Date: 2020-12-22 10:15:48
 * description: 自增表单
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import { Form, message } from "antd";
import YxAction from "../YxAction";
import createForm from "./createForm";
import Icon from "../YxText/Icon";
import { set, isObject, isArray, isEqual, isFunction } from "lodash";
import YxDynamicForm from "../YxDynamicForm";
import { YxComponent } from "../YxComponent";
import { get } from "../../utils";
import { getFormData, componentSelect } from "./tools";
import Basics from "../YxInput/Basics";
import "./index.less";

@Form.create()
class IncrementForm extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.formDomeRefs = React.createRef();
    this.state = {
      formValue: this.props.remoteValues || [],
    };
    this.getFormValue = () => {};
  }

  componentDidMount() {
    // get(this.props, 'load', () => { })({
    //     submit: this.submit,
    //     form: this.props.form,
    //     tabs: this.state.tabs,
    //     save: this.save,
    //     form: this.props.form,
    //     getValues: this.getValues,
    // })
    // this.formItemTemplateCreat(this.setFormValues)
  }

  componentWillReceiveProps(nextProps) {
    if (
      !isEqual(nextProps.remoteValues, this.props.remoteValues) &&
      nextProps.remoteValues != "" &&
      isArray(nextProps.remoteValues)
    ) {
      this.setState({ formValue: nextProps.remoteValues });
    }
  }

  getValues = (values) => {
    const values_ = values || this.getFormValue();
    const result = Object.values(values_);
    return result;
  };

  /**
   * description: 提交数据调用
   * param :
   * return {*}
   */
  submit = () => {
    return new Promise((resolve) => {
      this.props.form.validateFieldsAndScroll((err, values) => {
        if (err == null) {
          const result = Object.values(values);
          resolve(result);
          // get(this.props, 'onSubmit', () => { })(values)
        } else {
          resolve(null);
        }
      });
    });
  };

  /**
   * 重置item ps：主要给数组中标记加入下标，id，mutex.ids
   *
   */
  resetItems = (item) => {
    const index = this.state.formValue.length;
    const newItem = { ...item };
    const id = get(item, "controlItemParam.id", "");
    const mutex = this.mutexAddIndex(get(item, "mutex.ids", []), index);
    set(newItem, "mutex.ids", mutex);
    set(newItem, "mutex.formId", index.toString()); //给互斥加上表单自增id
    set(newItem, "controlItemParam.id", `[${index}].${id}`);

    if (get(item, "type") === "YxPopup") {
      const templateItem = get(newItem, "templateItem", {});
      const resources = get(this.props, "resources", {});
      const mutex = this.mutexAddIndex(
        get(item, "controlItemParam.mutex.ids", []),
        index
      );
      set(templateItem, "id", newItem.id);
      set(newItem, "controlItemParam.mutex.ids", mutex);
      set(newItem, "controlItemParam.mutex.formId", index.toString()); //给互斥加上表单自增id
      set(newItem, "controlItemParam.DOM", componentSelect(templateItem));
    }
    return newItem;
  };
  /**
   * description:
   * param : mutex 数组
   * return: [[index]mutex] 包含下表mutex
   */
  mutexAddIndex = (mutex = [], index = "") => {
    let index_ = index != null ? `[${index}].` : "";
    return mutex.map((item) => {
      return `${index_}${item}`;
    });
  };

  delJsx = (index) => {
    const del = () => {
      const formValue = this.getValues();
      formValue.splice(index, 1);
      this.setState({ formValue });
      this.incrementChange(formValue);
    };
    const DOM = <Icon type="minus-circle-o" onClick={del} />;
    return DOM;
  };

  /**
   * description: 自增添加按钮
   * param : type [init,click] init:初始化时调用 click 点击时调用
   * return {type}
   */
  add = () => {
    let { formValue } = this.state;
    const maxCount = get(this.props, "item.maxCount", false);
    if (maxCount && formList.length === maxCount) {
      message.error(`已达到最大限制${maxCount}条数据，不能再新增了`);
    } else {
      formValue.push({});
      this.setState(formValue);
      this.incrementChange(this.getValues());
    }
  };

  incrementChange(values) {
    const { onChange } = this.props;
    console.log("child", values);
    // this.setState({ formValue: Object.values(values) });
    isFunction(onChange) && onChange(Object.values(values));
  }
  templateInsertAction = (index) => {
    const template = [...this.props.template];
    let action = {
      //表单控件类型
      type: "Extend",
      controlItemParam: {
        id: "acion",
        label: "",
        children: this.delJsx(index),
      },
    };
    template.push(action);
    return template;
  };

  /**
   * description: 生成formItem 配置 分组配置参数
   * param :
   * return {*}
   */
  get formItems() {
    const { label, remoteValues } = this.props;
    const result = [];
    const { formValue = [] } = this.state;
    // const values = this.getValues(remoteValues);
    for (let i = 0; i < formValue.length; i++) {
      const template = this.templateInsertAction(i);
      const groupParam = {
        showArrow: false,
        isFold: false,
        forceRender: true,
        header: label && `${label} - ${i + 1}`,
        styleParam: { type: "border", size: "border" },
      };
      const formItem_group = createForm(groupParam, template, i);
      result.push(formItem_group);
    }
    return result;
  }
  /**
   * description: 监听 props && formItems
   * param :
   * return {formParams}
   */
  get formParams() {
    return {
      form: this.props.form,
      formParam: {
        form: this.formItems,
        noPanel: true,
        deSerializationData: this.state.formValue,
      },
      onFormChange: (values, index) => {
        this.incrementChange(values);
      },
    };
  }
  formLoad = (getFormValue) => {
    this.getFormValue = getFormValue;
  };

  render() {
    return (
      <div className="yx_increment_form">
        <YxDynamicForm {...this.formParams} load={this.formLoad} />
        <div className="operation special_operation">
          <YxAction
            icon="plus"
            type="dashed"
            onClick={() => {
              this.add("click");
            }}
            className="add_btn"
          >
            新增
          </YxAction>
        </div>
      </div>
    );
  }
}

class Index extends YxComponent {
  render() {
    const props = { ...this.props };
    let classParam = {
      yx_yxColorPicker_: "styleParam.type",
      yx_yxColorPicker_width_: "styleParam.width",
      yx_yxColorPicker_size_: "styleParam.size",
    };
    if (props.isFormItem) {
      set(props, "getFieldDecoratorParam.valuePropName", "remoteValues");
      set(
        props,
        "inputParam.className",
        this.styleParamClassName(props, classParam)
      );
      props.children = <IncrementForm {...props}></IncrementForm>;
      let html = Basics.html(props);

      return html;
    } else {
      set(props, "className", this.styleParamClassName(props, classParam));
      return <IncrementForm {...props}></IncrementForm>;
    }
    // const { saveType } = this.props;
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxIncrementForm/incrementForm.js